import { useRole } from '../../utils/RoleContext';
import getAdminRoutes from '../AdminRoutes';
import { ProtectRouteAdmin } from '../ProtectRouteAdmin';

export default function AdRoutes() {
    const { role } = useRole();

    return {
        path: '/',
        element: <ProtectRouteAdmin />,
        children: getAdminRoutes(role)
    };
}
